<template>
  <!-- 用户审批 -->
  <el-dialog v-dialogDrag v-loading="loading" title="请假申请（审批）" :visible.sync="dlgVisible" :close-on-click-modal="false"
    :close-on-press-escape="false" width="800px">
    <div>
      <!-- 业务组件 -->
      <ctrl ref="ctrl" />
      <!-- 流程节点 -->
      <p class="name">审批流程</p>
      <applicationFlow ref="applicationFlow" />
      <div v-if="params.viewParam == 'approve'">
        <div v-if="currentFlowNodeName === '人事主管'">
          <!-- 自定义审批组件 -->
          <hrManagerApproveCtrl ref="hrManagerApproveCtrl" @getFormData="getFormData" @afterAgree="finishApprove"
            @afterReject="finishApprove" @afterTransfer="finishApprove" />
        </div>
        <div v-else>
          <userApprove ref="userApprove" @getFormData="getFormData" @afterAgree="finishApprove"
            @afterReject="finishApprove" @afterTransfer="finishApprove" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import ctrl from "./index";
import leaveService from "@/CommonDP/service/leave-service";
import applicationFlow from "@/CommonDP/pages/components/launchFlow/components/applicationFlow";
import userApprove from "@/CommonDP/pages/components/launchFlow/components/userApprove";
import flowUtils from "@/CommonDP/utils/flowUtils";
import hrManagerApproveCtrl from "./hrManagerApproveCtrl";

export default {
  components: { ctrl, applicationFlow, userApprove, hrManagerApproveCtrl },
  data() {
    return {
      loading: false,
      dlgVisible: false,
      params: {},
      showBotton: false,
      flowNodesEditorVisible: false,
      showStartButtons: false,
      currentNodeKey: "",
      currentFlowNodeName: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj
    })
  },
  methods: {
    // 接口：约定给框架提供的方法
    openForApproval(params) {
      console.debug(params);
      this.params = params;
      this.reset();
      this.dlgVisible = true;
      this.flowNodesEditorVisible = true;
      this.$nextTick(() => {
        this.$refs.applicationFlow.setFlowStatus(this.params.status);
        this.$refs.applicationFlow.queryCCUserIdList();
        this.queryDetail(params);
      });
    },

    reset() {
      this.loading = false;
      this.dlgVisible = false;
      this.showBotton = false;
      this.flowNodesEditorVisible = false;
      this.showStartButtons = false;
    },

    async queryDetail(params) {
      const res = await leaveService.queryDetail(params.flowInstanceId);
      const data = res.data || {};
      this.$refs.ctrl.setFormData(data.businessData || {});
      this.$refs.applicationFlow.setNodeList(data.nodes);
      const node = flowUtils.findCurrentNode(data.nodes);
      this.currentNodeKey = node?.nodeKey;
      this.currentFlowNodeName = node?.flowNodeName;
      console.debug("node..........", node);
    },

    // 由审批控件发出的通知，请求设置审批数据
    getFormData() {
      if (this.$refs.ctrl?.getFormData) {
        const json = this.$refs.ctrl.getFormData();
        this.$refs.userApprove.setFormData(json);
      }
    },
    finishApprove() {
      this.dlgVisible = false;
      this.$emit("refreshList");
    }
  }
};
</script>

<style>
</style>
